import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import HeaderTitle from './HeaderTitle'
import ListCompany from './listCompany'
import {
  createIdsOfCurrentPage,
  createListChecked,
  resetStore,
} from './store/slice'
import withLoadingFeedback from './withLoadingFeedback'

const Content = ({
  selectIds,
  selectDataFromRedux,
  selectPaginationInfo,
  setPage,
  setPageSize,
  hiddenSelectAll,
}) => {
  const dispatch = useDispatch()

  const paginationInfo = useSelector(selectPaginationInfo)
  const ids = useSelector(selectIds)
  const { metaData } = paginationInfo

  useEffect(() => {
    dispatch(createListChecked(metaData))
    dispatch(createIdsOfCurrentPage(ids))

    return () => dispatch(resetStore())
  }, [])

  return (
    <div className="h100 flexColumn">
      <HeaderTitle
        selectPaginationInfo={selectPaginationInfo}
        hiddenSelectAll={hiddenSelectAll}
      />
      <ListCompany
        ids={ids}
        selectDataFromRedux={selectDataFromRedux}
        selectPaginationInfo={selectPaginationInfo}
        setPage={setPage}
        setPageSize={setPageSize}
      />
    </div>
  )
}

export default withLoadingFeedback(Content)
